var React = require('react');

function Capacity (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.31383 7.31832L7.31133 6.31032L8.72883 3.45432H18.2576L19.6863 6.31032L17.6838 7.30712L16.8738 5.69432H10.1238L9.31383 7.31832ZM20.9463 10.1743H15.8501L14.9613 6.81432H12.0363L11.1476 10.1743H6.05133L4.61133 13.0303L6.62508 14.0271L7.44633 12.4143H19.5513L20.3613 14.0383L22.3751 13.0415L20.9463 10.1743ZM19.9901 25.8543H17.6613L17.3913 24.8463L13.4988 19.0223L9.59508 24.8463L9.33633 25.8543H7.00758L10.2588 13.5343H12.5876L12.1826 15.0463L13.4988 17.0063L14.8038 15.0463L14.4101 13.5343H16.7388L19.9901 25.8543ZM12.8238 18.0143L11.8113 16.5023L10.4838 21.5199L12.8238 18.0143ZM16.5138 21.5087L15.1863 16.4911L14.1738 18.0143L16.5138 21.5087Z","fill":"#FECD12"}));
}

Capacity.defaultProps = {"width":"27","height":"29","viewBox":"0 0 27 29","fill":"none"};

module.exports = Capacity;

Capacity.default = Capacity;
